<template>
  <div id="zt8350">
    <div id="z1">
      <div>ZT8350 {{$store.state.iscn?'税控产品':'Fiscal Terminal'}}</div>
      <label>{{$store.state.iscn?'金融级别，保密没商量':'Financial grade, high security'}}</label>
    </div>
    <div id="z2">
      <label v-if="$store.state.iscn">ZT8350是证通自主研发的新一代智能税控终端，增加了金融POS级别的拆机监测机制，安全税控模块采用金融级别的密码键盘技术，支持国际上各种通用加密算法。</label>
      <h5 v-else>
        Anti-dismantle Various encryption algorithms Assemble financial-grade encrypted pinpad 
      </h5>
    </div>
    <div id="z3">
      <div>{{$store.state.iscn?'内置安全税控  数据不丢失':'Data protection'}}</div>
      <label>{{$store.state.iscn?'设计有大容量的非易失性存储器用做税控数据备份，在设备不能工作的情况下仍能方便读取':'Large-capacity non-volatile memory backup'}}</label>
    </div>
    <div id="z4">
      <span v-if="$store.state.iscn">
        <div>扩展力强  功能丰富</div>
        <label>支持1个USB host、1个钱箱接口</label>
        <label>1个RJ45、1个RS232、1个电源</label>
      </span>
      <span v-else>
        <h5>Strong expansion power and rich functions</h5>
        <h5>USB x1、Cash drawer x1、RJ45 Ethernet x1、RS232x1、Power x1</h5>
      </span>
    </div>
    <payscene :data="sdata"></payscene>
    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      sdata: {
        data: [
          {
            pic: require('@/assets/pic/zt8350/s1.png'),
            label: _this.$store.state.iscn?'开具税票':'Receipt issuing'
          },
          {
            pic: require('@/assets/pic/zt8350/s2.png'),
            label: _this.$store.state.iscn?'商品售卖':'Vending'
          },
          {
            pic: require('@/assets/pic/zt8350/s3.png'),
            label: _this.$store.state.iscn?'零售商店':'Retail'
          },
        ]
      },
      spdata: {
        file: 'ZT8350',
        data: [
          {label: '处理器', desc: ['ARM四核1.1GHz高速处理器','32位高性能安全处理器'],pic: 'cpu.png'},
          {label: '存储器', desc: ['1GB RAM+8GB ROM','2GB RAM+16GB ROM（可选）','支持MicrosSD扩展，最大32GB'],pic: 'ram.png'},
          {label: '操作系统', desc: ['Android 5.1 / 7.1','证通安全操作系统（ZOS）'], pic: 'sys.png'},
          {label: '屏幕', desc: ['主显：3.5英寸320×240 TFT','副显：132x32 点阵显示屏'], pic: 'disp.png'},
          {label: '税控模块', desc: ['128MB加密存储','支持3DES、AES、RSA、SHA-256等算法'], pic: 'tax.png'},
          {label: '移动网络', desc: ['支持 GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['支持IEEE 802.11 b /g/ n,2.4GHz'], pic: 'wifi.png'},
          {label: '蓝牙', desc: ['支持蓝牙 4.0及以上','支持BLE'], pic: 'blt.png'},
          {label: '定位', desc: ['内置GPS / 北斗 / Glonass','支持LBS功能','支持AGPS'], pic: 'lbs.png'},
          {label: '打印机', desc: ['内置58mm高速热敏打印机','支持外径40mm纸卷'], pic: 'prt.png'},
          {label: '扬声器', desc: ['内置扬声器，功率0.5W','声压82dB±3dB'], pic: 'speaker.png'},
          {label: '接口', desc: ['USB host×1、 钱箱接口×1','RJ45×1、RS232×1、电源×1'], pic: 'port.png'},
          {label: '按键', desc: ['键盘按键×30', '电源键×1','音量键×2'], pic: 'keyt.png'},
          {label: '指示灯', desc: ['充电指示灯×1、电源指示灯×1','网络指示灯×1、用户自定义×1'], pic: 'lamp.png'},
          {label: '适配器', desc: ['输入：AC 100~240V','输出：DC 9V/4A'], pic: 'char.png'},
          {label: '尺寸（长×宽×高）', desc: ['230mm×105mm×45mm'], pic: 'size.png'},
          {label: '适用环境', desc: ['工作温度： 0℃～+50℃ ','存储温度：-20℃～+70℃','相对湿度：10%～90% RH (不结露)'], pic: 'env.png'}
        ]
      },
      spdata_en: {
        file: 'ZT8350',
        data: [
          {label: 'Processor', desc: ['Quad core@1.1GHz'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['1GB RAM+8GB ROM','2GB RAM+16GB ROM（Optional）','MicroSD x1 support up to 32 GB'],pic: 'ram.png'},
          {label: 'OS', desc: ['ZOS based on Android 5.1/7.1'], pic: 'sys.png'},
          {label: 'Display', desc: ['Primary: 3.5"320 x 240 TFT','Secondary: 132x32 dot matrix'], pic: 'disp.png'},
          {label: 'Fiscal Module', desc: ['128M encrypted storage','3DES,AES, RSA,SHA-256,etc.'], pic: 'tax1.png'},
          {label: 'Cellular Network', desc: ['GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['IEEE 802.11 b /g/ n', '2.4GHz'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 4.0 and above','BLE'], pic: 'blt.png'},
          {label: 'Location', desc: ['Built-in GPS/Beidou/Glonass','LBS','AGPS'], pic: 'lbs.png'},
          {label: 'Printer', desc: ['58mm thermal printer','40mm roll paper'], pic: 'prt.png'},
          {label: 'Speaker', desc: ['Built-in speaker, 0.5W','82dB±3dB'], pic: 'speaker.png'},
          {label: 'Port', desc: ['USB ×1、Cash drawer x1','RJ45 Ethernet x1、RS232x1', 'Power x1'], pic: 'port.png'},
          {label: 'Keypad', desc: ['Physical keys x30', 'Power x1', 'Volume keysx2'], pic: 'keyt.png'},
          {label: 'Indicator', desc: ['Charging ×1、power x 1', 'Network x 1、user-defined x1'], pic: 'lamp.png'},
          {label: 'Battery', desc: ['Lithium battery 7.4V/2550mAH'], pic: 'battery.png'},
          {label: 'Adapter', desc: ['Input: AC100-240V', 'Output: DC 9v/4A'], pic: 'char.png'},
          {label: 'Dimension(LxWxH)', desc: ['230mm×105mm×45mm'], pic: 'size.png'},
          {label: 'Environment', desc: ['Working temp: 0℃~+50℃', 'Storage temp: -20°℃~+70°℃', 'Relative humidity : 10%~90%RH(non-condensing)'], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8350 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8350/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 9.88rem;
}
#z1 div {
  margin-top: 4.06rem;
  font-size: .6rem;
  font-weight: bold;
  color: #4D4B49;
}
#z1 label {
  display: block;
  font-weight: 400;
  margin-top: .25rem;
  font-size: .4rem;
  font-weight: 400;
  color: #565959;
  margin-left: .02rem;
}
#z1 img {
  width: 4.9rem;
}
#z2 {
  height: 1.78rem;
  background: #A6A6A6;
  text-align: center;
  overflow: hidden;
}
#z2 label {
  display: inline-block;
  width: 12.18rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}
#z2 h5 {
  margin: .58rem auto 0 auto;
  font-size: .24rem;
  font-weight: 500;
  color: #FFFFFF;
  width: 5.5rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8350/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.46rem;
}
#z3 div {
  margin: 3.22rem 0 .2rem 0;
  font-size: .56rem;
  font-weight: bold;
  color: #4D4B49;
}
#z3 label {
  margin-left: .05rem;
  width: 5.4rem;
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #333333;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8350/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.48rem;
}
#z4 div {
  margin-top: 2.79rem;
  margin-bottom: .29rem;
  font-size: .6rem;
  font-weight: bold;
}
#z4 label {
  margin-left: .01rem;
  font-size: .24rem;
  font-weight: 400;
  display: block;
  color: #333333
}

#z4 h5:nth-child(1) {
  font-size: .55rem;
  font-weight: 400;
  color: #4D4D4D;
  width: 7rem;
  margin: 2.6rem 0 0 0;
}
#z4 h5:nth-child(2) {
  font-size: .3rem;
  font-weight: 400;
  color: #595959;
  width: 7rem;
  margin: .1rem 0 0 0;
}

</style>
